/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable array-callback-return */
/* eslint-disable no-empty */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import PixIcon from '@mui/icons-material/Pix';
import ArticleIcon from '@mui/icons-material/Article';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Loader from '../../../Loader';

import GoogleImg from '../../../../assets/google-pay-mark.png';
import api from '../../../../services/api';

import {
  CardHeader,
  CardInfo,
  CardsContainer,
  CardTitle,
  Container,
  Divider,
  PaymentCard,
} from './styles';
import TicketingService from '../../../../services/ticketing';

interface IPaymentMethod {
  selectedPayment?: any;
  onSelectPayment: (payment: any) => void;
  onCollapsedChange?: (collapsed: boolean) => void;
}

const PaymentMethod: React.FC<IPaymentMethod> = ({
  selectedPayment,
  onSelectPayment,
  onCollapsedChange,
}) => {
  const [loading, setLoading] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);

  const services = { ticketingService: new TicketingService() };

  const [formPayment, setFormPayment] = useState<any>(null);

  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  const applePayRef = useRef<HTMLElement>(null);

  const [collapsed, setCollapsed] = useState(false);

  const getPaymentMethods = useCallback(async () => {
    try {
      setLoading(true);

      const response = await services.ticketingService.getBoletoLimit();

      const results = response?.data?.results || [];

      setPaymentMethods(results);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSelect = (payment: any) => {
    const isSamePayment = formPayment === payment.payment_type;

    if (isSamePayment) {
      setFormPayment(null);
      setCollapsed(false);
      onCollapsedChange(false);
      return;
    }

    setFormPayment(payment.payment_type);

    onSelectPayment(payment);

    setCollapsed(true);
    onCollapsedChange(true);
  };

  useEffect(() => {
    getPaymentMethods();
  }, []);

  useEffect(() => {
    if (!window.google?.payments?.api) {
      return;
    }

    const paymentsClient = new window.google.payments.api.PaymentsClient({
      environment: process.env.REACT_APP_GOOGLE_PAY_ENV,
    });

    const checkReady = async () => {
      try {
        const isReady = await paymentsClient.isReadyToPay({
          apiVersion: 2,
          apiVersionMinor: 0,

          allowedPaymentMethods: [
            {
              type: 'CARD',

              parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],

                allowedCardNetworks: [
                  'AMEX',
                  'DISCOVER',
                  'INTERAC',
                  'JCB',
                  'MASTERCARD',
                  'VISA',
                ],
              },
            },
          ],
        });

        if (!isReady.result) {
          return;
        }

        const button = paymentsClient.createButton({
          buttonType: 'buy',
          buttonColor: 'black',
          buttonLocale: 'pt',
          buttonSizeMode: 'fill',

          onClick: () => {},
        });

        const container = document.getElementById('google-pay-button-buy');

        if (!container) {
          return;
        }

        container.innerHTML = '';

        container.appendChild(button);
      } catch (error) {
        console.log(error);
      }
    };

    checkReady();
  }, [paymentMethods, formPayment]);

  const filteredPayments = useMemo(() => {
    return paymentMethods.filter(payment => {
      if (payment.payment_type === 'applepay') {
        return isApplePayAvailable;
      }

      return true;
    });
  }, [paymentMethods, isApplePayAvailable]);

  useEffect(() => {
    const available =
      !!window.ApplePaySession && window.ApplePaySession.canMakePayments();

    console.log({
      hasApplePaySession: !!window.ApplePaySession,
      available,
    });

    setIsApplePayAvailable(available);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <CardsContainer>
        {formPayment ? (
          <p className="text">Forma de pagamento selecionada:</p>
        ) : (
          <p className="text">Selecione a forma de pagamento:</p>
        )}
        {filteredPayments.map(payment => {
          const selected = selectedPayment?.id === payment.id;
          const hidden = !!formPayment && payment.payment_type !== formPayment;
          return (
            <>
              <PaymentCard
                key={payment.id}
                selected={selected}
                hidden={hidden}
                onClick={() => handleSelect(payment)}
              >
                <>
                  <CardHeader>
                    {payment.payment_type === 'googlepay' ? (
                      formPayment === 'googlepay' ? (
                        <CardTitle>Google Pay</CardTitle>
                      ) : (
                        <div
                          id="google-pay-button-buy"
                          style={{
                            width: '80%',
                            display: 'block',
                            height: '40px',
                          }}
                        />
                      )
                    ) : payment.payment_type === 'applepay' ? (
                      formPayment === 'applepay' ? (
                        <CardTitle>Apple Pay</CardTitle>
                      ) : (
                        <apple-pay-button
                          buttonstyle="black"
                          type="buy"
                          locale="pt"
                          style={{
                            pointerEvents: 'none',
                            minWidth: '271px',
                            height: '40px',
                            width: '80%',
                            display: 'block',
                            padding: '10px',
                          }}
                        />
                      )
                    ) : payment.payment_type === 'pix' ? (
                      <CardTitle
                        style={{
                          height: '40px',
                        }}
                      >
                        <PixIcon style={{ marginLeft: '10px' }} />
                        {payment.payment_type_display}
                      </CardTitle>
                    ) : payment.payment_type === 'credit_card' ? (
                      <CardTitle
                        style={{
                          height: '40px',
                        }}
                      >
                        <CreditCardIcon />
                        {payment.payment_type_display}
                      </CardTitle>
                    ) : (
                      <CardTitle
                        style={{
                          height: '40px',
                        }}
                      >
                        <ArticleIcon />
                        {payment.payment_type_display}
                      </CardTitle>
                    )}
                  </CardHeader>

                  <>
                    <Divider />

                    <CardInfo collapsed={collapsed && selected}>
                      <p>
                        Valor mínimo: R${' '}
                        {String(payment.minimum).replace('.', ',')}
                      </p>

                      <p>
                        Valor máximo: R${' '}
                        {String(payment.maximum).replace('.', ',')}
                      </p>
                    </CardInfo>
                  </>
                  {!payment.enable && (
                    <p
                      style={{
                        color: '#ff6b00',
                        marginTop: 12,
                      }}
                    >
                      {payment.warning}
                    </p>
                  )}
                </>
              </PaymentCard>
            </>
          );
        })}
      </CardsContainer>
    </Container>
  );
};

export { PaymentMethod };
